import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { SubscriptionSubjectType, SubscriptionType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { SUBSCRIPTIONS, SUBSCRIPTIONS_SUBJECTS } from "../../../utils/constants";

export const getSubscriptions = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        IdValidated: String(data?.IdValidated ?? true),
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.Semester ? { Semester: `${data.Semester}` } : {}),
        ...(data?.Level ? { Level: `${data.Level}` } : {}),
        ...(data?.SearchTerm ? { SearchTerm: `${data.SearchTerm}` } : {}),
        ...(data?.Regime ? { Regime: `${data.Regime}` } : {}),
        ...(data?.HasClassForThisLevelYearSemester ? { HasClassForThisLevelYearSemester: `${data.HasClassForThisLevelYearSemester}` } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdValidated ? { IdValidated: `${data.IdValidated}` } : {}),
    });

    const url = `${SUBSCRIPTIONS}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubscriptionType>>(url)
};
export const getSubjectsSubscriptions = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear } : {}),
        ...(data?.Semester ? { Semester: `${data.Semester}` } : {}),
        ...(data?.Level ? { Level: `${data.Level}` } : {}),
        ...(data?.IdSubscription ? { IdSubscription: data.IdSubscription } : {}),
    });
    const url = `${SUBSCRIPTIONS_SUBJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubscriptionSubjectType>>(url)
};